(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/router.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.Router = svs.app.ServerSideHelper.ServerSideRouterDecorator.decorate({
    initialize: function initialize() {
      var logger = svs.core.log.getLogger('module;player-login');
      this.setDefaultRegion(svs.player_login.app.getRegion());
      this.on('route', function () {
        logger.debug("Current url: ".concat(decodeURIComponent(window.location.href)));
      });
    },
    routes: svs.core.data.routes,
    start: function start() {
      var model = svs.player_login.radio.request('loginModel'),
          logger = svs.core.log.getLogger('module:player-login');

      if (model.get('isCustomerRegistration')) {
        model.set('currentTab', 'bankid');
      } else {
        svs.core.deviceSession.get('currentLoginMethod', 'customer_login', function (result, err) {
          if (err) {
            logger.debug('Error when getting current login method from device session.');
          }

          model.set('currentTab', !svs.core.detect.feature('ft-frejaid') && result === 'frejaeid' ? 'bankid' : result || 'bankid'); 

          if (model.get('hideInIosApp') && model.get('currentTab') === 'frejaeid') {
            model.set('currentTab', 'bankid');
          }
        });
      }

      if (svs.core.detect.formfactor.mobile() && !model.get('isStandardMobile')) {
        this.navigate("/mobilt-bankid?".concat(model.toQueryString('bankid')), true);
      } else {
        this.showView(svs.player_login.views.Start, {
          model: model
        });
      }
    },
    usernameActions: function usernameActions() {
      this.showView(svs.player_login.views.Actions, {
        model: svs.player_login.radio.request('loginModel')
      });
    },
    bankIdLogin: function bankIdLogin() {
      var model = svs.player_login.radio.request('loginModel');

      if (this.isRenderedServerSide) {
        model.set('startBankId', false);
      }

      this.showView(svs.player_login.views.bankid.Poll, {
        model: model
      });
    },
    bankidSameDevice: function bankidSameDevice() {
      this.showView(svs.player_login.views.bankid.SameDevice, {
        model: svs.player_login.radio.request('loginModel')
      });
    },
    bankidOtherDevice: function bankidOtherDevice() {
      this.showView(svs.player_login.views.bankid.OtherDevice, {
        model: svs.player_login.radio.request('loginModel')
      });
    },
    usernameLogin: function usernameLogin() {
      this.showView(svs.player_login.views.username.Login, {
        model: svs.player_login.radio.request('loginModel')
      });
    },
    frejaEidLogin: function frejaEidLogin() {
      var model = svs.player_login.radio.request('loginModel');

      if (this.isRenderedServerSide) {
        model.set('startFrejaEid', false);
      }

      this.showView(svs.player_login.views.frejaeid.Poll, {
        model: model
      });
    },
    frejaEidSameDevice: function frejaEidSameDevice() {
      this.showView(svs.player_login.views.frejaeid.SameDevice, {
        model: svs.player_login.radio.request('loginModel')
      });
    },
    frejaEidOtherDevice: function frejaEidOtherDevice() {
      this.showView(svs.player_login.views.frejaeid.OtherDevice, {
        model: svs.player_login.radio.request('loginModel')
      });
    }
  });
})(Backbone, _, svs);
 })(window);